module.exports = __webpack_public_path__ + "static/media/1B.7d8bb88e.svg";